import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import Photo from "../media/Photo";
import Link from "shared/components/navigation/links/Link";

export const Container = styled.div`
    margin-top: 1.5rem;
    text-align: left;
`;

export const Content = styled(Row)`
    margin: 0.5rem 0 0;
    border: ${globalThis.config.border.small};
    border-radius: 0.3rem;
    padding: 0.5rem;
`;

export const Column = styled(Col)`
    padding: 0;
`;

export const PictureColumn = styled(Col)`
    min-width: 3.5rem;
    padding: 0;
    margin: 0;
`;

export const EmployeePicture = styled(Photo)`
    width: 3rem;
    height: 3rem;
`;

export const Contact = styled.div`
    margin-top: 1rem;
    margin-left: -0.5rem;
`;

export const ExternalLink = styled.a`
    color: ${globalThis.config.colors.black};
    text-decoration: none;
    display: inline-flex;
    &:hover {
        text-decoration: none;
        color: ${globalThis.config.colors.black};
    }
`;

export const EmailLink = styled(Link)`
    color: ${globalThis.config.colors.black};
    display: inline-flex;
`;

export const CopyContainer = styled.div`
    padding: 0 0.5rem 0.25rem;
    border-radius: 0.25rem;
    margin: 0.25rem 0;
    &:hover {
        color: ${globalThis.config.colors.black};
        background-color: ${globalThis.config.colors.gray8};
        div {
            visibility: visible;
        }
    }
`;

export const Tip = styled.div`
    margin-left: 0.5rem;
    text-align: right;
    display: inline-flex;
    visibility: hidden;
    > svg {
        margin-right: 0.25rem;
    }
`;
